import styled from "styled-components";

export const BeginnersGuideInviteDesktopOverlayStyled = styled.div`
    width: 384px;
    height: 195px;
    position: fixed;
    right: 316px;
    bottom: 360px;
    background: radial-gradient(38.08% 73.59% at 61.59% 100%, rgba(255, 239, 98, 0.12) 22.74%, rgba(255, 239, 98, 0.00) 100%);
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    z-index: 1000;
    transition: opacity 0.3s ease-out;
    opacity: 1;

    &.hidden {
        opacity: 0;
    }
`;

export const BeginnersGuideInviteDialogDesktopStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 212px;
`;

export const BeginnersGuideInviteAvatarDesktopStyled = styled.div`
    flex: 1;
    position: relative;
    overflow: hidden;
    height: 215px;

    img {
        top: 0;
        right: 0;
        position: absolute;
        width: 172px;
        height: auto;
        transform: rotate(-6deg);
        flex-shrink: 0;
    }
`;

export const BeginnersGuideInviteMessageDesktopStyled = styled.div`
    padding: 8px 12px;
    border-radius: 16px 16px 4px 16px;
    background: var(--gradient-primary);
    color: var(--color-label-neutral-primary-black);
    font-size: 14px;
`;

export const BeginnersGuideInviteButtonsDesktopStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-bottom: 10px;
`;